import { render } from "./Edit.vue?vue&type=template&id=3448b08a"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/PurchaseReqs/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3448b08a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3448b08a', __exports__)) {
    console.log('reload')
    api.reload('3448b08a', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=3448b08a", () => {
    console.log('re-render')
    api.rerender('3448b08a', render)
  })

}


export default __exports__